import { render, staticRenderFns } from "./media.vue?vue&type=template&id=37f84e6f&scoped=true&"
import script from "./media.vue?vue&type=script&lang=js&"
export * from "./media.vue?vue&type=script&lang=js&"
import style0 from "./media.vue?vue&type=style&index=0&id=37f84e6f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f84e6f",
  null
  
)

export default component.exports